var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginRevampFooterTollFreeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.25,
    width: 24.5,
    height: 24.5,
    rx: 12.25,
    fill: "#C7222A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.25,
    width: 24.5,
    height: 24.5,
    rx: 12.25,
    stroke: "white",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41333 11.6933C10.3733 13.58 11.92 15.1267 13.8067 16.0867L15.2733 14.62C15.46 14.4333 15.72 14.38 15.9533 14.4533C16.7 14.7 17.5 14.8333 18.3333 14.8333C18.5101 14.8333 18.6797 14.9036 18.8047 15.0286C18.9298 15.1536 19 15.3232 19 15.5V17.8333C19 18.0101 18.9298 18.1797 18.8047 18.3047C18.6797 18.4298 18.5101 18.5 18.3333 18.5C15.3275 18.5 12.4449 17.306 10.3195 15.1805C8.19404 13.0551 7 10.1725 7 7.16667C7 6.98986 7.07024 6.82029 7.19526 6.69526C7.32029 6.57024 7.48986 6.5 7.66667 6.5H10C10.1768 6.5 10.3464 6.57024 10.4714 6.69526C10.5964 6.82029 10.6667 6.98986 10.6667 7.16667C10.6667 8 10.8 8.8 11.0467 9.54667C11.12 9.78 11.0667 10.04 10.88 10.2267L9.41333 11.6933Z",
    fill: "#FFFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginRevampFooterTollFreeIcon);
export default __webpack_public_path__ + "static/media/login-revamp-footer-tollFree-icon.ae5a677f5ffc0404c46e08de733f4d74.svg";
export { ForwardRef as ReactComponent };